import { ConfigItem } from '../base-definitions'
import { ViewColumnAlignment, ViewColumnBehaviour, ViewColumnDetail } from '../enums'
import { FieldDefinition } from '../field-definitions'
import { TooltipDefinition } from '../form-definitions'
import { DefinitionUtils } from '../utils'

export class ViewColumnDefinition {
  public fieldName: string
  public width: string
  public inlineDefinition: FieldDefinition | null
  public hidden: boolean
  public overrideIDML: string
  public overrideDescription: string
  public customUI: string
  public autoHeight: boolean
  public behaviour: ViewColumnBehaviour
  public disableColumnFilter: boolean
  public disableColumnSorting: boolean
  public config: ConfigItem[]
  public detail: ViewColumnDetail
  public tooltip: TooltipDefinition | null
  public alignment: ViewColumnAlignment
  public ellipsis: boolean

  constructor(model: ViewColumnDefinition) {
    this.fieldName = model.fieldName
    this.width = model.width
    this.inlineDefinition = model.inlineDefinition ? DefinitionUtils.mapFieldDefinition(model.inlineDefinition) : null
    this.hidden = model.hidden
    this.overrideIDML = model.overrideIDML
    this.overrideDescription = model.overrideDescription
    this.customUI = model.customUI
    this.autoHeight = model.autoHeight
    this.behaviour = model.behaviour
    this.disableColumnFilter = model.disableColumnFilter
    this.disableColumnSorting = model.disableColumnSorting
    this.config = model.config
    this.detail = model.detail
    this.tooltip = model.tooltip
    this.alignment = model.alignment
    this.ellipsis = model.ellipsis
  }
}
